import { useQuery } from "@tanstack/react-query";
import queryKeys from "../../constants/queryKeys";
import documentService from "../../services/documentService";

const useAccountFiles = (accountId, fileTypeHS, documentType) =>
    useQuery({
        queryKey: [queryKeys.accountFiles, fileTypeHS, accountId],
        queryFn: () => documentService.fetchAccountFiles(accountId, fileTypeHS, documentType),
        enabled: !!accountId || !!fileTypeHS,
    });

export default useAccountFiles;
